const sliderController = () => {
  jQuery('.tab-content.webinars .video-resource .video-boxes').each(function (index, single) {
    jQuery(single).slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      responsive: [{
        breakpoint: 1279,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  });

  jQuery('.video-boxes .slick-arrow').empty();


};


$( document ).ready( function() {
  sliderController();
});

